import React from 'react';
import { stats } from '../../data/stats';
import './Problema.css';

const Problema = () => {
  return (
    <section id="problema" className="section problema">
      <div className="container">
        <span className="section-eyebrow">O Problema</span>
        <h2 className="section-title">Desafios na Pecuária Moderna</h2>
        <p className="section-subtitle">A pecuária enfrenta desafios significativos na gestão animal que impactam diretamente a produtividade, a segurança sanitária e a rentabilidade do negócio.</p>
        
        <div className="stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-percentage">{stat.percentage}</div>
              <div className="stat-description">{stat.description}</div>
              <p>{stat.text}</p>
            </div>
          ))}
        </div>
        
        <div className="impacto-financeiro">
          <h3>Impacto Financeiro Direto</h3>
          <p>Estima-se que as falhas na gestão sanitária resultem em prejuízos anuais de até 15% do faturamento dos produtores.</p>
        </div>
      </div>
    </section>
  );
};

export default Problema;